/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../../../services/axiosConfig";
import { toast } from "react-toastify";

function NovoDolarModal({ isOpen, toggle, onSave, dolarParaEditar }) {
  const [data, setData] = useState(new Date());
  const [valor, setValor] = useState("");

  const parseMMYYYY = (dateString) => {
    if (!dateString || typeof dateString !== 'string') {
      return new Date();
    }
    const [mes, ano] = dateString.split('/');
    return new Date(parseInt(ano), parseInt(mes) - 1, 1);
  };

  useEffect(() => {
    if (isOpen) {
      if (dolarParaEditar) {
        setValor(String(dolarParaEditar.value));
        setData(parseMMYYYY(dolarParaEditar.createdAt));
      } else {
        setValor("");
        setData(new Date());
      }
    }
  }, [isOpen, dolarParaEditar]);

  async function handleSave() {
    if (!data || !valor) {
      toast.warn("Por favor, preencha todos os campos.");
      return;
    }

    const formatToMMYYYY = (date) => {
      const mes = (date.getMonth() + 1).toString().padStart(2, '0');
      const ano = date.getFullYear();
      return `${mes}/${ano}`;
    };

    const dataDeReferencia = new Date(data);
    dataDeReferencia.setMonth(dataDeReferencia.getMonth() - 1);

    const dados = {
      dateRef: formatToMMYYYY(dataDeReferencia),
      value: parseFloat(valor.replace(",", ".")),
      createdAt: formatToMMYYYY(data),
    };

    try {
      if (dolarParaEditar) {
        await api.put(`/dolar/${dolarParaEditar._id}`, { ...dados });
        toast.success("Valor do Dólar atualizado com sucesso!");
      } else {
        await api.post("/dolar", { ...dados });
        toast.success("Valor do Dólar cadastrado com sucesso!");
      }

      onSave();
      toggle(); 
    } catch (error) {
      toast.error(error.response?.data?.message || "Erro ao salvar o valor do Dólar.");
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {dolarParaEditar ? "Editar Valor do Dólar" : "Cadastrar Novo Valor do Dólar"}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="valorDolar">Valor do Dólar</Label>
          <Input
            type="text"
            id="valorDolar"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            placeholder="Ex: 5,25"
            autoComplete="off"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="dataDolar">Mês do valor do dólar</Label>
          <br />
          <DatePicker
            selected={data}
            onChange={(date) => setData(date)}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            locale={ptBR}
            className="form-control"
            id="dataDolar"
            autoComplete="off"
            required
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>
          Salvar
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default NovoDolarModal;